import { render, staticRenderFns } from "./CampaignOthers.vue?vue&type=template&id=21630a7b"
import script from "./CampaignOthers.vue?vue&type=script&lang=js"
export * from "./CampaignOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports